var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3122 5.57959L9.68164 7.99997L13.3122 10.4204V5.57959Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47111 4.36938H2.42015C1.75178 4.36938 1.20996 4.91121 1.20996 5.57958V10.4203C1.20996 11.0887 1.75178 11.6305 2.42015 11.6305H8.47111C9.13948 11.6305 9.6813 11.0887 9.6813 10.4203V5.57958C9.6813 4.91121 9.13948 4.36938 8.47111 4.36938Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5223,
    height: 14.5223,
    fill: "white",
    transform: "translate(0 0.738831)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminVideo);
export default __webpack_public_path__ + "static/media/admin_video.0d5306b2a981ed2073f24d11da0869e9.svg";
export { ForwardRef as ReactComponent };